// Imports
import axios from 'axios';

// Export actions
/**
 * Get a list of Orders.
 * @param {Object} { token: string, query: string, direction: string, order: string, limit: number, page: number}
 * @return {AxiosPromise} Http request
 */
export const getOrders = ({ token, query, direction, order, limit, page }) => {
  const params = {
    q: query || null,
    direction,
    order,
    limit,
    page,
  };

  let urlString = '';

  Object.keys(params).map(i => {
    urlString += params[i] ? `&${i}=${params[i]}` : '';
    return i;
  });

  urlString = urlString.length > 0 ? `?${urlString.slice(1)}` : '';

  return axios({
    method: 'get',
    url: `${window.API_URL}/orders${urlString}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Get a specific Order.
 * @param {Object} { token: string, id: number}
 * @return {AxiosPromise} Http request
 */
export const getOrder = ({ token, id }) => {
  const params = {
    id,
  };

  let urlString = '';

  Object.keys(params).map(i => {
    urlString += params[i] ? `&${i}=${params[i]}` : '';
    return i;
  });

  urlString = urlString.length > 0 ? `?${urlString.slice(1)}` : '';

  return axios({
    method: 'get',
    url: `${window.API_URL}/orders${urlString}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Create an Order.
 * @param {Object} { token: string, payload: { } }
 * @return {AxiosPromise} Http request
 */
export const createOrder = ({ token, payload }) =>
  axios({
    method: 'post',
    url: `${window.API_URL}/orders`,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });

/**
 * Update an Order.
 * @param {Object} { token: string, payload: {  } }
 * @return {AxiosPromise} Http request
 */
export const updateOrder = ({ token, id, payload }) =>
  axios({
    method: 'put',
    url: `${window.API_URL}/orders/${id}`,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });

/**
 * Delete an Order.
 * @param {Object} { token: string, id: integer }
 * @return {Promise} axios promise
 */
export const deleteOrder = ({ token, id }) => {
  return axios({
    method: 'delete',
    url: `${window.API_URL}/orders/${id}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};
